module.exports = __webpack_public_path__ + "media/images/store/app_store_hover-b05b2c3a0eb58fb6742b17cce198794d.png";